import React from 'react';
import AgencyList from './AgencyList';
import { selectNavHeight } from "../../../../redux/navbar/navHeightSlice";
import { useSelector } from "react-redux";


const Agency = () => {
    const navHeight = useSelector(selectNavHeight);

    return (

        <div  className="mx-auto w-full"
        style={{
          marginTop: navHeight,
          height: `calc(100vh - ${navHeight}px)`,
          overflow: "auto",
        }} >
                <AgencyList />
            </div>
    );
};

export default Agency;

